import Constants from '../utils/constants';

const TAB_INDEX = Constants.TAB_INDEX;
const TAB_TYPE = Constants.TAB_TYPE;

let tabs = {};

tabs[TAB_TYPE.MAIN] = {
    urlKey: 'tab',
    qaAttrValue: '',
    sendAnalyticsEventOnTabChange: true,
    items: {
        circuit: {
            name: 'circuit',
            description: 'Circuit',
            index: TAB_INDEX.MAIN.CIRCUIT,
            default: true,
            error: 'circuitError',
            errorsExist: 'circuitError',
            overrideTabError: true,
            qaAttrValue: 'ckt_tab',
            hasIcon: true
        },
        noise: {
            name: 'noise',
            description: 'Noise & Distortion',
            index: TAB_INDEX.MAIN.NOISE_DISTORTION,
            errorsExist: 'isNoiseDistortionTabError',
            qaAttrValue: 'noise_and_dist_tab',
            hasIcon: true
        },
        settling: {
            name: 'settling',
            description: 'Input Settling',
            index: TAB_INDEX.MAIN.INPUT_SETTLING,
            errorsExist: 'isSettlingTabError',
            qaAttrValue: 'in_sttlng_tab',
            hasIcon: true
        },
        nextSteps: {
            name: 'next-steps',
            description: 'Next Steps',
            index: TAB_INDEX.MAIN.NEXT_STEPS,
            qaAttrValue: 'nxt_steps_tab',
            hasIcon: true
        },
        driverPerformance: {
            name: 'driver-performance',
            index: TAB_INDEX.MAIN.DRIVER_PERFORMANCE,
            error: 'tempABError',
            errorItems: 'tempABErrorItems',
            hideRequirements: ['notInDebugMode']
        }
    }
};

tabs[TAB_TYPE.NOISE] = {
    urlKey: 'nTab',
    qaAttrValue: 'noise_and_dist',
    items: {
        thd: {
            name: 'thd',
            description: 'Thd',
            index: TAB_INDEX.NOISE.THD,
            default: true,
            errorsExist: 'isThdTabError'
        },
        noise: {
            name: 'noise-calculations',
            description: 'Noise',
            index: TAB_INDEX.NOISE.NOISE
        }
    }
};

tabs[TAB_TYPE.SETTLING] = {
    urlKey: 'sTab',
    qaAttrValue: 'in_sttlng',
    items: {
        dc: {
            name: 'dc',
            description: 'DC',
            index: TAB_INDEX.SETTLING.DC,
            default: true,
            errorsExist: 'bwWarnings.isDcTab'
        },
        ac: {
            name: 'ac',
            description: 'AC',
            index: TAB_INDEX.SETTLING.AC,
            errorsExist: 'bwWarnings.isSinTab',
            hideRequirements: ['selectedAdcHasFixedKickbackType']
        },
        muxed: {
            name: 'muxed',
            description: 'Muxed',
            index: TAB_INDEX.SETTLING.MUXED,
            errorsExist: 'bwWarnings.isMuxedTab',
            hideRequirements: ['isNotMultiplexed', 'isInternalMultiplexed']
        }
    }
};

export default {
    tabs: tabs
}